// Lib
import * as _ from 'lodash';
import { put, call, takeLatest } from "redux-saga/effects";

// Constants
import * as ACTIONS from "./actionTypes";

// Types
import { ActionGetLMDepartmentsAPI, getLMDepartmentsAPISuccess, getLMDepartmentsAPIError, getLMDepartmentsAPI, ActionPostListing, ActionGetEngineLocationsAPI, getEngineLocationsAPISuccess, getEngineLocationsAPIError, postListingSuccess } from './actions';
import { EngineLocations, UIDepartments } from './types';

import { createAPINetworkInstance } from '../../../../../common/api';
import { parseAPILMdepartments, parseAPIEngineLocations } from './utils';
import { ListingType, ListingUI } from 'features/Dealers/Listings/state/types';
import { parseListingAPI} from 'features/Dealers/Listings/state/utils';

function* getDealerLMDepartments(action: ActionGetLMDepartmentsAPI) {
    try {

        const { idengine, iddealer } = action
        const { data } = yield call(createAPINetworkInstance().get, `dealers/${iddealer}/departments`);
        const lmdepartments: UIDepartments = parseAPILMdepartments(data);
        yield put(getLMDepartmentsAPISuccess(lmdepartments));
    } catch (err) {
        yield put(getLMDepartmentsAPIError(err));
    }
}


function* postListing(action: ActionPostListing) {
    try {
        const { dealerId, engineId, department } = action
        const body = {
            listings: department.map(dp => ({
                dealerId,
                id: dp.listingId,
                listingType: ListingType.DEPARTMENT,
                idInSource: dp.engineLocationId,
                engineId,
                listingTypeId: dp.name
            })
            )
        };



        const response = yield call(createAPINetworkInstance().post, `listings`, body);    
        const listings: ListingUI[] = response.data?.listings?.map(parseListingAPI) ?? [];        

        
        //Change deparments and post Succes
        const newLiveDepartments = department.map(department => {
            const id = department.name;
            let listingFound: ListingUI | undefined
            if (listings) {
                listingFound = _.find(listings, { deparmentId: id })
            }
            return {
                ...department,
                listingId:  listingFound ? (listingFound.idInSource== null? undefined: listingFound.id) : undefined,
                engineLocationId: listingFound ? listingFound.idInSource : undefined
            }
        })   
                

        yield put(postListingSuccess(listings,newLiveDepartments));
    } catch (err) {
        yield put(getLMDepartmentsAPIError(err));
    }
}

function* getDealerLMEngineLocations(action: ActionGetEngineLocationsAPI) {
    try {

        const { engineId, dealerId } = action
        const { data } = yield call(createAPINetworkInstance().get, `dealer/${dealerId}/engine/${engineId}/locations`);
        const engineLocations: EngineLocations = parseAPIEngineLocations(data);
        
        yield put(getEngineLocationsAPISuccess(engineLocations));
    } catch (err) {
        yield put(getEngineLocationsAPIError());
    }
}


export default function* dealerLMDepartmentsSagas() {
    yield takeLatest(ACTIONS.POST_LISTINGS_API_REQUEST, postListing);
    yield takeLatest(ACTIONS.GET_LMDEPARTMENTS_API_REQUEST, getDealerLMDepartments);
    yield takeLatest(ACTIONS.GET_ENGINELOCATIONS_API_REQUEST, getDealerLMEngineLocations);
}
